/** Stabiler, eindeutiger React-Key pro Tax-/Transfer-Zeile (Multi-Event-TX-safe). */
export function getTaxRowKey(tx = {}, idx = 0) {
  if (tx.rowId != null && tx.rowId !== "") return String(tx.rowId);
  if (tx.event_id != null && tx.event_id !== "") return String(tx.event_id);

  const hash = String(
    tx.hash || tx.txid || tx.transactionHash || tx.event_id || ""
  ).toLowerCase();

  const logIdx = tx.log_index ?? tx.logIndex;
  const clauseIdx = tx.clause_index ?? tx.clauseIndex;
  const eventIdx = tx.event_index ?? tx.eventIndex;
  const subEvent = tx.subEventId ?? tx.sub_event_id;

  if (hash && logIdx != null) return `${hash}#log:${logIdx}`;
  if (hash && clauseIdx != null) return `${hash}#clause:${clauseIdx}`;
  if (hash && eventIdx != null) return `${hash}#evt:${eventIdx}`;
  if (hash && subEvent != null) return `${hash}#sub:${subEvent}`;

  if (hash) {
    return [
      hash,
      tx.classification || tx.type || "nocls",
      tx.token || tx.token_symbol || "notoken",
      tx.timestamp ?? tx.block_timestamp ?? "nots",
      tx.amount ?? "noamt",
      idx,
    ].join("|");
  }

  return [
    "nohash",
    tx.classification || tx.type || "nocls",
    tx.token || "notoken",
    tx.timestamp ?? "nots",
    tx.amount ?? "noamt",
    idx,
  ].join("|");
}

export function getTaxRowMobileKey(prefix, tx, idx = 0) {
  return `${prefix}-mobile-${getTaxRowKey(tx, idx)}`;
}

/**
 * Builds one React key per row and guarantees uniqueness within the list.
 *
 * Rows of a single transaction regularly share rowId, event_id or logIndex (for
 * example the reward legs of one claim). Duplicate keys make React reuse the
 * wrong children, which leaves stale rows on screen after a search or filter
 * shrinks the list, so every repeated identity gets an occurrence suffix.
 */
export function buildUniqueTaxRowKeys(rows = [], getIdentity = getTaxRowKey) {
  const seen = new Map();

  return (Array.isArray(rows) ? rows : []).map((row, idx) => {
    const base = String(getIdentity(row || {}, idx) || "") || `row:${idx}`;
    const occurrence = seen.get(base) || 0;
    seen.set(base, occurrence + 1);
    return occurrence === 0 ? base : `${base}#dup:${occurrence}`;
  });
}
